// ACTIONS
export const FETCH_DAILY_MATCHES = 'FETCH_DAILY_MATCHES';
export const FETCH_BRANDSAFETY_CLASSIFIERS = 'FETCH_BRANDSAFETY_CLASSIFIERS';
export const UPDATE_BRANDSAFETY_CLASSIFIERS = 'UPDATE_BRANDSAFETY_CLASSIFIERS';
export const UPDATE_MATCHES = 'UPDATE_MATCHES';
